module.exports = __webpack_public_path__ + "static/media/algorand_full_logo_black.50bbe1d1.svg";